/* KLIK theme behaviour: cart drawer, quick add, offers, COD form, gallery, timer, sticky bar */
(() => {
  const K = window.KLIK || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = cents => {
    const f = K.moneyFormat || '${{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2), noZero = v % 1 === 0 ? String(v) : two;
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v)).replace(/\{\{\s*amount\s*\}\}/, noZero).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','));
  };
  const toast = msg => { let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); } t.textContent = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 1800); };
  const track = (ev, data) => { try { if (window.fbq) fbq('track', ev, data || {}); } catch (e) {} };

  /* ---------- cart drawer ---------- */
  const cd = $('#cart-drawer');
  const setCount = n => $$('[data-cart-count]').forEach(e => { e.textContent = n; e.dataset.count = n; });
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const render = cart => {
    setCount(cart.item_count);
    if (!cd) return;
    const free = (K.freeShip || 0) * 100, sub = cart.total_price;
    const ship = $('.cd__ship', cd), items = $('.cd__items', cd), foot = $('.cd__foot', cd);
    if (!cart.item_count) {
      items.innerHTML = `<div class="cd__empty"><p>${esc(K.t.empty)}</p><a class="btn btn--accent" href="${K.routes.all}">${esc(K.t.shop)}</a></div>`;
      ship.hidden = true; foot.hidden = true; return;
    }
    ship.hidden = !free; foot.hidden = false;
    if (free) {
      const ok = sub >= free;
      ship.classList.toggle('ok', ok);
      $('span', ship).textContent = ok ? K.t.freeOk : K.t.freeLeft.replace('[amount]', money(free - sub));
      $('i', ship).style.width = Math.min(100, Math.round(sub / free * 100)) + '%';
    }
    items.innerHTML = cart.items.map(it => `
      <div class="cd__item" data-key="${it.key}">
        <a class="cd__img" href="${it.url}">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" width="68" height="68" loading="lazy">` : ''}</a>
        <div class="cd__meta">
          <b>${esc(it.product_title)}</b>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<small>${esc(it.variant_title)}</small>` : ''}
          <span class="price"><span class="price__now">${money(it.final_price)}</span>${it.original_price > it.final_price ? `<span class="price__was">${money(it.original_price)}</span>` : ''}</span>
          <div class="cd__row">
            <div class="qty"><button type="button" data-q="-1" aria-label="${esc(K.t.less)}">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="${esc(K.t.more)}">+</button></div>
            <b>${money(it.final_line_price)}</b>
          </div>
        </div>
      </div>`).join('');
    $('[data-sub]', foot).textContent = money(cart.items_subtotal_price);
    const disc = cart.items_subtotal_price - cart.total_price;
    const dl = $('[data-disc-line]', foot); dl.hidden = disc <= 0; $('[data-disc]', foot).textContent = '−' + money(disc);
    $('[data-ship]', foot).textContent = free && sub >= free ? K.t.free : K.t.shipCalc;
    $('[data-total]', foot).textContent = money(cart.total_price);
  };
  const getCart = () => fetch('/cart.js').then(r => r.json());
  const open = () => { if (!cd) return; cd.classList.add('open'); document.body.style.overflow = 'hidden'; $('.cd__close', cd).focus(); };
  const close = () => { if (!cd) return; cd.classList.remove('open'); document.body.style.overflow = ''; };
  if (cd) {
    $('.cd__bg', cd).addEventListener('click', close);
    $('.cd__close', cd).addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && cd.classList.contains('open')) close(); });
    cd.addEventListener('click', e => {
      const b = e.target.closest('[data-q]'); if (!b) return;
      const row = b.closest('[data-key]'); const q = +$('.qty span', row).textContent + (+b.dataset.q);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity: Math.max(0, q) }) }).then(r => r.json()).then(render);
    });
  }
  $$('[data-open-cart]').forEach(a => a.addEventListener('click', e => { if (!cd) return; e.preventDefault(); getCart().then(c => { render(c); open(); }); }));
  const add = (id, quantity) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) })
    .then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)));

  /* quick add on cards */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    add(+b.dataset.quickAdd, 1).then(() => getCart()).then(c => {
      b.classList.add('added'); b.textContent = K.t.added; b.disabled = false;
      track('AddToCart', { content_ids: [b.dataset.quickAdd], content_type: 'product' });
      render(c); open();
    }).catch(err => { b.disabled = false; toast((err && err.description) || K.t.error); });
  });

  /* ---------- product page ---------- */
  const pf = $('[data-pdp]');
  if (pf) {
    const data = JSON.parse($('[data-product-json]', pf).textContent);
    const opt = JSON.parse($('[data-offer-json]', pf).textContent);
    let variant = data.variants.find(v => v.id === +pf.dataset.variant) || data.variants[0];
    let qty = 1;
    const setVariantFromInputs = () => {
      const chosen = $$('[data-opt]', pf).map(g => ($('input:checked', g) || {}).value);
      const v = data.variants.find(v => v.options.every((o, i) => o === chosen[i]));
      if (v) variant = v;
      update();
    };
    $$('[data-opt] input', pf).forEach(i => i.addEventListener('change', setVariantFromInputs));
    const offers = $$('[data-offer]', pf);
    offers.forEach(o => o.addEventListener('click', () => { qty = +o.dataset.offer; update(); }));
    const pctFor = q => q >= 3 ? opt.p3 : q === 2 ? opt.p2 : 0;
    const update = () => {
      const p = variant.price, cmp = variant.compare_at_price || 0;
      $$('[data-price]', pf).forEach(e => e.textContent = money(p));
      $$('[data-was]', pf).forEach(e => { e.textContent = cmp > p ? money(cmp) : ''; e.hidden = !(cmp > p); });
      $$('[data-save]', pf).forEach(e => { e.textContent = cmp > p ? K.t.save.replace('[amount]', money(cmp - p)) : ''; });
      offers.forEach(o => {
        const q = +o.dataset.offer, line = Math.round(p * q * (100 - pctFor(q)) / 100), full = (cmp > p ? cmp : p) * q;
        o.classList.toggle('on', q === qty); o.setAttribute('aria-pressed', q === qty);
        $('[data-o-now]', o).textContent = money(line);
        const w = $('[data-o-was]', o); w.textContent = full > line ? money(full) : ''; w.hidden = !(full > line);
      });
      const total = Math.round(p * qty * (100 - pctFor(qty)) / 100);
      const free = (K.freeShip || 0) * 100, shipTxt = free && total >= free ? K.t.free : (K.shipFee ? money(K.shipFee * 100) : K.t.shipCalc);
      $$('[data-sum-label]', pf).forEach(e => e.textContent = K.t.sumLabel.replace('[qty]', qty).replace('[ship]', shipTxt));
      $$('[data-sum-total]', pf).forEach(e => e.textContent = money(total + (free && total >= free ? 0 : (K.shipFee || 0) * 100)));
      const ok = variant.available;
      $$('[data-buy]', pf).forEach(b => b.disabled = !ok);
      $$('[data-soldout]', pf).forEach(e => e.hidden = ok);
      const hid = $('input[name="id"]', pf); if (hid) hid.value = variant.id;
      if (variant.featured_media) { const s = $(`[data-media="${variant.featured_media.id}"]`, pf); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      if (history.replaceState && data.variants.length > 1) history.replaceState(null, '', location.pathname + '?variant=' + variant.id);
    };
    /* add to cart instead */
    $$('[data-add-cart]', pf).forEach(b => b.addEventListener('click', () => {
      b.disabled = true;
      add(variant.id, qty).then(() => getCart()).then(c => { b.disabled = false; track('AddToCart', { content_ids: [String(variant.id)], value: variant.price / 100, currency: K.currency }); render(c); open(); })
        .catch(err => { b.disabled = false; toast((err && err.description) || K.t.error); });
    }));
    /* COD form: goes to Shopify checkout with the address already filled */
    const form = $('[data-cod]', pf);
    if (form) form.addEventListener('submit', e => {
      e.preventDefault();
      let ok = true;
      $$('[required]', form).forEach(i => { const f = i.closest('.fld'); let good = i.value.trim().length > 1; if (i.type === 'tel') good = i.value.replace(/\D/g, '').length >= 7; f.classList.toggle('bad', !good); if (!good && ok) { ok = false; i.focus(); } });
      if (!ok) return;
      const v = n => (form.elements[n] ? form.elements[n].value.trim() : '');
      const parts = v('name').split(/\s+/); const first = parts.shift() || ''; const last = parts.join(' ') || '-';
      const phone = '+961' + v('phone').replace(/\D/g, '').replace(/^961/, '').replace(/^0/, '');
      const q = new URLSearchParams();
      q.set('checkout[shipping_address][first_name]', first);
      q.set('checkout[shipping_address][last_name]', last);
      q.set('checkout[shipping_address][phone]', phone);
      q.set('checkout[shipping_address][address1]', v('address'));
      q.set('checkout[shipping_address][city]', v('city'));
      q.set('checkout[shipping_address][country]', 'Lebanon');
      q.set('attributes[order_source]', 'cod_form');
      track('InitiateCheckout', { content_ids: [String(variant.id)], value: variant.price * qty / 100, currency: K.currency, num_items: qty });
      const btn = $('button[type="submit"]', form); btn.disabled = true; btn.textContent = K.t.going;
      location.href = `/cart/${variant.id}:${qty}?${q.toString()}`;
    });
    /* gallery thumbs */
    const track_ = $('.gal__track', pf);
    $$('.gal__thumbs button', pf).forEach((b, i) => b.addEventListener('click', () => {
      const s = track_.children[i]; if (s) track_.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      $$('.gal__thumbs button', pf).forEach(x => x.classList.toggle('on', x === b));
    }));
    if (track_) track_.addEventListener('scroll', () => { const i = Math.round(track_.scrollLeft / track_.clientWidth); $$('.gal__thumbs button', pf).forEach((x, j) => x.classList.toggle('on', j === i)); }, { passive: true });
    update();
    track('ViewContent', { content_ids: [String(variant.id)], content_type: 'product', value: variant.price / 100, currency: K.currency });
  }

  /* ---------- deal timer: counts down to midnight Beirut time ---------- */
  const timers = $$('[data-timer]');
  if (timers.length) {
    const tick = () => {
      const now = new Date(); const bey = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Beirut' }));
      const end = new Date(bey); end.setHours(24, 0, 0, 0);
      let s = Math.max(0, Math.floor((end - bey) / 1000));
      const t = [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].map(n => String(n).padStart(2, '0')).join(':');
      timers.forEach(e => e.textContent = t);
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- sticky bar shows after the first screen ---------- */
  const st = $('.sticky');
  if (st) { const f = () => st.classList.toggle('show', scrollY > 420); addEventListener('scroll', f, { passive: true }); f(); }
  $$('[data-scroll-to]').forEach(a => a.addEventListener('click', e => { const t = $(a.dataset.scrollTo); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); const i = $('input', t); if (i) setTimeout(() => i.focus({ preventScroll: true }), 500); }));

  /* ---------- mobile menu ---------- */
  const dn = $('#nav-drawer');
  $$('[data-open-nav]').forEach(b => b.addEventListener('click', () => { dn.classList.add('open'); b.setAttribute('aria-expanded', 'true'); }));
  if (dn) $$('[data-close-nav]', dn).forEach(b => b.addEventListener('click', () => { dn.classList.remove('open'); $$('[data-open-nav]').forEach(x => x.setAttribute('aria-expanded', 'false')); }));

  /* sort select on collections */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); }));
})();
